/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserProvider, ClientProvider, ClientUserProvider} from '../../../providers';
import {SearchableItem} from '../../../model/interface/searchable.item';
import {Client, Helpers} from '../../../model';
import {PresetValue} from '../../../model/preset-value';
import {SearchableSelection} from '../../../model/interface/searchable.selection';
import {InputType} from '../../../model/enums/input.type';
import {CreateNewTypes} from '../../../model/enums/create.type';
import { LogService } from 'src/app/services';


@Component({
  selector: 'page-test',
  templateUrl: 'test.page.html',
  styleUrls: ['test.page.scss']
})
export class TestPage implements OnInit, OnDestroy {

  users: SearchableItem[] = [];
  clients: SearchableItem[] = [];
  clientUsers: SearchableItem[] = [];

  inputValue = 'Test Ronnel';
  inputNumber = 999333555;
  myMoney = 183982;
  myLabel = 'My Label';

  typeOfInput = InputType;
  typesOfData = CreateNewTypes;

  presetItems: SearchableItem[];
  stateItems: SearchableItem[] = [];
  // Test
  selClientTest: Client;

  constructor(
    public userProvider: UserProvider,
    public clientProvider: ClientProvider,
    public clientUserProvider: ClientUserProvider,
    private logService : LogService

  ) {}

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.stateItems = Helpers.getDefaultStates();
    this.presetItems = [];

    const preset1 = new PresetValue();
    preset1.NAME = 'Processor';
    preset1.SCRIPT = 'PROCESSOR';



  }

  processPresetValue(value: SearchableSelection): void {
    this.logService.log(JSON.stringify(value, null, 2));
  }

}
